import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
const TextInput = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <TextField
      variant="standard"
      fullWidth={props.fullWidth}
      label={props.label}
      InputLabelProps={{ shrink: true }}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={props.value}
      type={props.type}
      onChange={props.onChange}
      onFocus={props.onFocus}
      onKeyDown={props.onKeyDown}
      disabled={props.disabled}
      placeholder={props.placeholder}
      InputProps={{
        ...props.InputProps,
        endAdornment: props.InputProps ? (
          <InputAdornment position="start">
            <div
              style={{
                // backgroundColor: "#09a0f2",
                backgroundColor: isHovered ? "#ff0" : "#09a0f2",
                width: "36px",
                height: "30px",
                paddingLeft: "6px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onMouseEnter={() => setIsHovered(true)} // マウスが要素に入ったらホバー状態をtrueに
              onMouseLeave={() => setIsHovered(false)} // マウスが要素から出たらホバー状態をfalseに
              onClick={props.onClick}
            >
              <SearchIcon />
            </div>
          </InputAdornment>
        ) : null,
        sx: {
          "& .MuiInput-underline:before": {
            borderBottomColor: "#09a0f2", // 通常時の下線の色
          },
          "& .MuiInput-underline:after": {
            borderBottomColor: "#09a0f2", // フォーカス時の下線の色
          },
          "& .MuiInput-underline:hover:before": {
            borderBottomColor: `${"#09a0f2"}!important`, // ホバー時の下線の色
          },
          "& .MuiInput-underline": {
            borderBottomColor: `${"#09a0f2"}!important`, // ホバー時の下線の色
          },
          // 他のスタイルもここに追加できます
        },
      }}
      sx={{
        "&&&": {
          margin: "0px",
          color: "blue",
          width: "210px",
          margin: "0 5px",
          backgroundColor: "#202226",
          padding: "10px 10px 5px 10px",
          borderRadius: "5px",
        },
        "& label": {
          padding: "10px",
          color: "#09a0f2",
          fontSize: "18px",
        },
        "& svg": {
          marginTop: "5px",
          color: "#f0f2f5",
        },
        "& input": {
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: "5px",
          paddingLeft: "10px",
          fontSize: "20px",
          color: "#09a0f2",
          fontWeight: "700",
          //   backgroundColor: "black",
        },
        // InputPropsで指定したスタイル以外にもここで追加できます
      }}
    />
  );
};
export default TextInput;
